import axios from 'axios'
import router from '@/router'
import { Message } from 'element-ui'

// 根据环境变量设置API基础地址
const BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://sale.zaoying.cn/api'  // 生产环境直接使用完整API地址
  : '/api'  // 开发环境使用代理

const service = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: false
})

service.interceptors.request.use(
  config => {
    try {
      const remembered_Token = localStorage.getItem('remembered_Token')
      if (remembered_Token) {
        // const parsed = JSON.parse(raw)
        // const token = parsed && parsed.token
        // if (remembered_Token) {
          // config.headers.Authorization = `Bearer ${remembered_Token}`
        // }
      }
    } catch (e) {
      // ignore parse errors
    }

    if (config.method === 'post' && !(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json;charset=utf-8'
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    // 如果是二进制响应（blob），直接返回完整响应对象
    if (response.config.responseType === 'blob') {
      return response
    }
    
    const data = response.data
    if (data && typeof data.code !== 'undefined') {
      const isSuccess = data.code === 0 || data.code === 200
      if (isSuccess) {
        return typeof data.data !== 'undefined' ? data.data : data
      }
      const msg = data.msg || data.message || '请求失败'
      Message && Message.error(msg)
      if (data.code === 401) {
        handleUnauthorized()
      }
      return Promise.reject(new Error(msg))
    }
    return data
  },
  error => {
    //const status = error && error.response && error.response.status
    // let msg = '网络错误，请稍后重试'
    // if (status === 401) {
    //   msg = '登录已过期，请重新登录'
    //   handleUnauthorized()
    // } else if (status === 403) {
    //   msg = '没有权限访问'
    // } else if (status === 404) {
    //   msg = '接口不存在 (404)'
    // } else if (status >= 500) {
    //   msg = '服务器开小差了，请稍后再试'
    // } else if (error && error.code === 'ECONNABORTED') {
    //   msg = '请求超时，请检查网络'
    // } else if (error && error.message) {
    //   msg = error.message
    // }
    // Message && Message.error(msg)
    return Promise.reject(error)
  }
)

function handleUnauthorized () {
  try {
    localStorage.removeItem('userInfo')
  } catch (e) {
    // Ignore localStorage errors
  }
  const current = router && router.currentRoute
  if (current && current.path !== '/') {
    router.replace({ path: '/', query: { redirect: current.fullPath } }).catch(() => {})
  }
}

const request = config => service(config)

const get = (url, params, config = {}) => service({ url, method: 'get', params, ...config })
const post = (url, data, config = {}) => service({ url, method: 'post', data, ...config })
const put = (url, data, config = {}) => service({ url, method: 'put', data, ...config })
const del = (url, params, config = {}) => service({ url, method: 'delete', params, ...config })
const upload = (url, formData, config = {}) => service({
  url,
  method: 'post',
  data: formData,
  headers: { 'Content-Type': 'multipart/form-data' },
  ...config
})

export default request
export { service, get, post, put, del, upload }


